import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Tag } from '@teetsh/app/src/components/Tag';
import { useGetDirectorRoutes } from '@teetsh/app/src/containers/Header/useGetDirectorRoutes';
import { ButtonClose } from '@teetsh/app/src/containers/Sidebar/components/ButtonClose';
import { Logo } from '@teetsh/app/src/containers/Sidebar/components/Logo';
import { SidebarWrapper } from '@teetsh/app/src/containers/Sidebar';
import { NavItem } from '@teetsh/app/src/containers/Sidebar/NavItem';
import { useSidebarStatus } from '@teetsh/app/src/containers/Sidebar/useSidebarStatus';
import { useUserRoles } from '@teetsh/app/src/containers/App/context/useUserRoles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import tw from 'twin.macro';
import { useNavigate } from 'react-router-dom';

export function SidebarDirector() {
  const location = useLocation();
  const { isOpen } = useSidebarStatus();
  const items = useGetDirectorRoutes();
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  const { hasRoleTeacher } = useUserRoles();

  return (
    <SidebarWrapper theme="light">
      <div
        css={[
          tw`flex justify-between mb-6 sm:px-2 relative`,
          isOpen && tw`visible pr-3`,
          !isOpen && tw`invisible`,
        ]}
      >
        <div css={[tw`flex gap-4 `]}>
          <Logo theme="light" to="/direction/school-subscription" />
          <Tag color="gris-moderate">{t('common:director')}</Tag>
        </div>
        <div tw="block lg:hidden">
          <ButtonClose />
        </div>
      </div>
      <div tw="flex flex-col flex-grow mb-4">
        {items.map(item => (
          <NavItem
            key={item.route}
            minimal={!isOpen}
            item={item}
            pathname={location.pathname}
            theme="light"
          />
        ))}
      </div>

      {hasRoleTeacher && (
        <Button
          onClick={() => {
            navigate('/dashboard');
          }}
          fill
          icon={ArrowsRightLeftIcon}
        >
          {isOpen && t('common:teacherAccount')}
        </Button>
      )}
    </SidebarWrapper>
  );
}
